import api from '../utils/api';

/**
 * Create a Razorpay order for a website plan tier purchase.
 * Tiers are sourced from the published page layout — no separate DB fetch needed.
 *
 * @param {{ page_slug: string, tier_id: string, buyer_name: string, buyer_phone: string, buyer_email?: string, library_name: string }} payload
 * @returns {Promise<Object>} Order data including order_id, amount, key_id, prefill.
 */
export async function createWebsitePlanOrder(payload) {
  const res = await api.post('/website-plans/order', payload);
  if (res?.data && res.data.error === false) {
    return res.data.data;
  }
  throw new Error(res?.data?.message || 'Failed to create order');
}

/**
 * Verify a completed Razorpay payment for a website plan.
 * Idempotent — safe to call multiple times with the same IDs.
 *
 * @param {{ razorpay_order_id: string, razorpay_payment_id: string, razorpay_signature: string }} payload
 * @returns {Promise<Object>} Purchase and plan snapshot data.
 */
export async function verifyWebsitePlanPayment(payload) {
  const res = await api.post('/website-plans/verify', payload);
  if (res?.data && res.data.error === false) {
    return res.data.data;
  }
  throw new Error(res?.data?.message || 'Payment verification failed');
}
